import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import Switch from "react-switch";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";

// Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
} from "../../store/functions";
import { constant } from "lodash";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

const Pass = (value, data) => {
  if (data.Password !== data.ConfirmPassword) {
    return "Password does not match";
  }
  return true;
};

class pageAddEdit_UserMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      formData: {},
      activeTab: 1,
      passedSteps: [1],
      BrowseImage1: "",
      BrowseImage2: "",
      UserImage: "",
      Signature: "",
      //dropdowns
      membershipType: [],
      maritalStatus: [],
      bloodGroup: [],
      gender: [],
      education: [],
      profession: [],
      relationShip: [],
      LedgerMaster: [],
      F_LedgerMaster: 0,
      nationality: [],
      typeofRegCert: [],
      memberid: 0,
      name: "",
      email: "",
      aid: 0,
      fo3: false,
      Gender: 0,
      MaritalStatus: 0,
      success_msg: false,
      F_MISScheme: 0,
      IsOvertime: false,
      EmpBasic: [],
      selectedRole: 0,
    };
    
    this.obj = this;
    this.formTitle = "User Master";
    this.breadCrumbTitle = "Memberships";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/User";
    this.API_URL_SAVE = API_WEB_URLS.User + "/0/token";
    this.pushFormName = "/UserMaster";
    this.rtPage_Print = "/membersynopsisprint";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
    this.API_URL_LEDGER = API_WEB_URLS.MASTER + "/0/token/LedgerMaster";
  }

  componentDidMount() {
    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    this.setState({
      name: obj.username,
      email: obj.email,
      aid: obj.uid,
      role: obj.role,
    });

    //Filling DropDowns
    //Fn_FillListData(this.obj, "membershipType", API_WEB_URLS.MASTER + "/0/token/MembershipType/Id/0");
    // Fn_FillListData(this.obj, "membershipType", API_WEB_URLS.MASTER + "/0/token/MembershipType/Id/0");

    const { id } = this.props.match.params;
    // const receivedId = this.props.location.state?.Id;
    console.log(this.props.location);
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      // Use async/await to properly handle the data loading
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id").then((formData) => {
        // Set the selected role based on the loaded form data
        if (formData && formData.F_UserRole) {
          const roleId = parseInt(formData.F_UserRole);
          this.setState({ 
            selectedRole: roleId,
            formData: formData
          });
          console.log("Loaded user data:", formData);
          console.log("Selected role:", roleId);
        }
      }).catch((error) => {
        console.error("Error loading form data:", error);
      });
    } else {
      this.setState({ id: 0 });
    }
    Fn_FillListData(this.obj, "LedgerMaster", this.API_URL_LEDGER + "/Id/0");
  }

  componentDidUpdate(prevProps, prevState) {
    // Log state changes for debugging
    if (prevState.selectedRole !== this.state.selectedRole) {
      console.log("Role changed from", prevState.selectedRole, "to", this.state.selectedRole);
    }
    
    if (prevState.formData !== this.state.formData) {
      console.log("Form data updated:", this.state.formData);
    }
  }

  btnSave_onClick(event, formData) {
    let vformData = new FormData();

    vformData.append("UserName", formData.Name);
    vformData.append("F_UserRole", formData.F_UserRole);
    vformData.append("UserPass", formData.Password || "");
    vformData.append("F_LedgerMaster", formData.F_LedgerMaster || 0);

    if (!this.state.id) {
      Fn_AddEditData(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "memberid"
      );
    } else
      Fn_AddEditData(
        this.obj,
        { arguList: { id: this.state.id, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "kuku"
      );
  }

  btnGoBack_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  OnPasswordChange = event => {
    var Password = event.target.value;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        Password: Password
      }
    }));
  };

  OnConfirmChange = event => {
    var ConfirmPassword = event.target.value;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        ConfirmPassword: ConfirmPassword
      }
    }));
  };

  onRoleChange = event => {
    const selectedRole = parseInt(event.target.value);
    this.setState({ selectedRole: selectedRole });
    
    // Also update the formData state to ensure the form reflects the change
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        F_UserRole: selectedRole
      }
    }));
  };

  onLedgerMasterChange = event => {
    const selectedLedgerId = parseInt(event.target.value);
    
    // Update the formData state to ensure the form reflects the change
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        F_LedgerMaster: selectedLedgerId
      }
    }));
  };

  getLedgerNameById = (ledgerId) => {
    if (!this.state.LedgerMaster || !ledgerId) return "";
    const ledger = this.state.LedgerMaster.find(item => item.Id === ledgerId);
    return ledger ? ledger.Name : "";
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    {/* <h4 className="card-title mb-4">Basic Wizard</h4> */}
                    <div className="wizard clearfix">
                      <div className="content clearfix">
                        <AvForm
                          className="needs-validation"
                          ref={c => (this.form = c)}
                          onValidSubmit={this.btnSave_onClick}
                        >
                          <TabContent
                            activeTab={this.state.activeTab}
                            className="body"
                          >
                            <TabPane tabId={1}>
                              <Row>
                                <Col lg="12">
                                  <Card>
                                    <CardBody>
                                      <h4 className="card-title mb-4">User Information</h4>
                                      <Row>
                                        {/* Role Selection */}
                                        <Col lg="6" md="6" sm="12" className="mb-3">
                                          <FormGroup>
                                            <Label for="F_UserRole" className="form-label">
                                              Role <span className="text-danger">*</span>
                                            </Label>
                                            <AvField
                                              name="F_UserRole"
                                              id="F_UserRole"
                                              value={
                                                this.state.formData.F_UserRole ===
                                                null || this.state.formData.F_UserRole === undefined
                                                  ? "0"
                                                  : this.state.formData.F_UserRole.toString()
                                              }
                                              errorMessage="Please select a role"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              type="select"
                                              className="form-select"
                                              onChange={this.onRoleChange}
                                            >
                                              <option value="0">Select Role</option>
                                              <option value="1">Admin</option>
                                              <option value="2">User</option>
                                              <option value="4">Customer</option>
                                            </AvField>
                                          </FormGroup>
                                        </Col>

                                        {/* Name Field */}
                                        <Col lg="6" md="6" sm="12" className="mb-3">
                                          <FormGroup>
                                            <Label for="Name" className="form-label">
                                              Name
                                            </Label>
                                            <AvField
                                              name="Name"
                                              id="Name"
                                              value={
                                                this.state.formData.UserName === null
                                                  ? ""
                                                  : this.state.formData.UserName
                                              }
                                              placeholder="Enter user name"
                                              errorMessage="Please enter a name"
                                              validate={{
                                                required: { value: false },
                                              }}
                                              type="text"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        {/* Ledger Master - Only show for Customer role */}
                                        {this.state.selectedRole === 4 && (
                                          <Col lg="6" md="6" sm="12" className="mb-3">
                                            <FormGroup>
                                              <Label for="F_LedgerMaster" className="form-label">
                                                Ledger Master
                                              </Label>
                                              <AvField
                                                name="F_LedgerMaster"
                                                id="F_LedgerMaster"
                                                                                              value={
                                                this.state.formData.F_LedgerMaster === null || 
                                                this.state.formData.F_LedgerMaster === undefined
                                                  ? "0"
                                                  : this.state.formData.F_LedgerMaster.toString()
                                              }
                                                placeholder="Select Ledger"
                                                errorMessage="Please select a ledger"
                                                validate={{
                                                  required: { value: false },
                                                }}
                                                type="select"
                                                className="form-select"
                                                onChange={this.onLedgerMasterChange}
                                              >
                                                <option value="0">Select Ledger</option>
                                                {this.state.LedgerMaster
                                                  ? this.state.LedgerMaster.map((option) => (
                                                      <option
                                                        key={option.Id}
                                                        value={option.Id}
                                                      >
                                                        {option.Name}
                                                      </option>
                                                    ))
                                                  : null}
                                              </AvField>
                                            </FormGroup>
                                          </Col>
                                        )}
                                        
                                        {/* Display Ledger Name for Customer when editing */}
                                        {this.state.selectedRole === 4 && 
                                         this.state.formData.F_LedgerMaster && 
                                         this.state.formData.F_LedgerMaster > 0 && (
                                          <Col lg="6" md="6" sm="12" className="mb-3">
                                            <FormGroup>
                                              <Label className="form-label">
                                                Ledger Name
                                              </Label>
                                              <Input
                                                type="text"
                                                className="form-control"
                                                value={this.getLedgerNameById(this.state.formData.F_LedgerMaster)}
                                                readOnly
                                                placeholder="Ledger Name"
                                              />
                                            </FormGroup>
                                          </Col>
                                        )}

                                        {/* Password Field */}
                                        <Col lg="6" md="6" sm="12" className="mb-3">
                                          <FormGroup>
                                            <Label for="Password" className="form-label">
                                              Password
                                            </Label>
                                            <AvField
                                              name="Password"
                                              id="Password"
                                              onChange={this.OnPasswordChange}
                                              value={
                                                this.state.formData.Password === null
                                                  ? ""
                                                  : this.state.formData.Password
                                              }
                                              placeholder="Enter password"
                                              errorMessage="Please enter a password"
                                              validate={{
                                                required: { value: false },
                                              }}
                                              type="password"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>

                                        {/* Confirm Password Field */}
                                        <Col lg="6" md="6" sm="12" className="mb-3">
                                          <FormGroup>
                                            <Label for="ConfirmPassword" className="form-label">
                                              Confirm Password
                                            </Label>
                                            <AvField
                                              name="ConfirmPassword"
                                              id="ConfirmPassword"
                                              onChange={this.OnConfirmChange}
                                              value={
                                                this.state.formData.ConfirmPassword === null
                                                  ? ""
                                                  : this.state.formData.ConfirmPassword
                                              }
                                              placeholder="Confirm password"
                                              errorMessage="Passwords do not match"
                                              validate={{ myValidation: Pass }}
                                              type="password"
                                              className="form-control"
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            </TabPane>
                          </TabContent>
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                            >
                              Save
                            </Button>
                            &nbsp;
                            <Button
                              type="button"
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                              onClick={this.btnGoBack_onClick}
                            >
                              Go Back
                            </Button>
                          </div>
                        </AvForm>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default compose(container)(pageAddEdit_UserMaster);
